module.exports = __webpack_public_path__ + "static/img/3.84926ae.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/zh/3.png
// module id = uNV5
// module chunks = 0